import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function cadastrocondutor(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@cadastrocondutor/FIND_CADASTROCONDUTOR':
      case '@cadastrocondutor/UPDATE_CADASTROCONDUTOR':
      case '@cadastrocondutor/DELETE_CADASTROCONDUTOR':
      case '@cadastrocondutor/STORE_CADASTROCONDUTOR':
      case '@cadastrocondutor/CADASTROCONDUTOR_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@cadastrocondutor/SUCCESS_REMOVE':
      case '@cadastrocondutor/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@cadastrocondutor/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.cadastrocondutor;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@cadastrocondutor/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.cadastrocondutor;
        break;
      }

      case '@cadastrocondutor/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
